$(function () {
    $('.hindle-index-articles .articles').uniformify({
        selector: '> .article'
    });

    $('.hindle-home-news .articles').uniformify({
        selector: '> .article, > .article .content'
    });
});
